import React, { Component } from 'react';
import { Link } from 'react-router-dom';

import { get, patch } from '../utils/apiClient';
import { COLOR } from './HomePanelComponent';
import { conVueltaAlHome } from '../utils/appMode';

// La puerta del evento de hoy, en el home. Va en los DOS homes (retail y cafetería): la puerta
// la puede atender quien está en el mostrador con el backoffice en modo retail.
//
// No repite ninguna regla del backend. La lista sale de `GET /manage-events/:id/admissions`
// (la misma de la pantalla de Anotados) y el ingreso se marca con el MISMO endpoint, que es el
// que decide si hoy se puede (NOT_EVENT_DAY), si la entrada está en condiciones y, en una
// jornada del club, sienta a la persona en su mesa. Lo que responde se muestra tal cual.
//
// Cobrar una entrada impaga y vender en la puerta NO se hacen acá: llevan a la pantalla de
// Anotados, que es donde viven esos flujos y sus reglas.

const FILAS_A_LA_VISTA = 8;

// Sin tildes y en minúscula: en la puerta se busca "Lucia" y la entrada dice "Lucía".
function normalizar(texto) {
    return String(texto || '')
        .normalize('NFD')
        .replace(/[̀-ͯ]/g, '')
        .toLowerCase()
        .trim();
}

function nombreDe(entrada) {
    if (entrada.holder_name) return entrada.holder_name;
    const cuenta = entrada.account;
    if (cuenta && (cuenta.firstName || cuenta.lastName)) {
        return [cuenta.firstName, cuenta.lastName].filter(Boolean).join(' ');
    }
    return 'Sin nombre';
}

class BandaEvento extends Component {

    constructor(props) {
        super(props);
        this.state = {
            entradas: null,
            puedeHoy: true,
            motivo: null,
            busqueda: '',
            verAdentro: false,
            trabajando: {},
            aviso: null,
            error: null,
        };
        this._desmontado = false;
    }

    componentDidMount() {
        this.cargar();
    }

    // El home de cafetería se recarga cada minuto y el componente NO se desmonta (va con
    // `key` = evento), así que el buscador no se borra mientras alguien tipea. La lista se
    // vuelve a pedir sólo si los contadores cambiaron (alguien marcó desde otra pantalla).
    componentDidUpdate(prev) {
        const a = prev.evento;
        const b = this.props.evento;
        if (a.ingresaron !== b.ingresaron || a.esperados !== b.esperados || a.sinCobrar !== b.sinCobrar) {
            this.cargar();
        }
    }

    componentWillUnmount() {
        this._desmontado = true;
    }

    cargar = () => get(`manage-events/${this.props.evento.eventId}/admissions?status=all`)
        .then((data) => {
            if (this._desmontado) return;
            this.setState({
                entradas: data.admissions || [],
                puedeHoy: data.event ? data.event.canRedeemToday !== false : true,
                motivo: data.event ? data.event.redeemBlockReason : null,
                error: null,
            });
        })
        .catch((error) => {
            if (this._desmontado) return;
            this.setState({ error: error.message || 'No se pudo cargar la lista' });
        });

    marcarIngreso = (entrada) => {
        const id = entrada.id;
        this.setState({ trabajando: { ...this.state.trabajando, [id]: true }, aviso: null });
        patch(`manage-events/${this.props.evento.eventId}/admissions/${id}/redeem`, {})
            .then((data) => {
                // En una jornada, el endpoint cuenta qué pasó con la mesa (se sentó, faltan
                // mesas, etc.). Es información para la puerta: se muestra, no se traga.
                // Los avisos vienen como objetos `{label, reason}` (la mesa y qué le pasó), no
                // como texto: se arman acá. Si llegara un string suelto, se muestra tal cual.
                const act = data && data.activity;
                const texto = (w) => (typeof w === 'string'
                    ? w
                    : [w && w.label, w && (w.reason || w.message)].filter(Boolean).join(': '));
                const avisos = act ? [act.message].concat((act.warnings || []).map(texto)).filter(Boolean) : [];
                this.setState({ aviso: avisos.length ? `${nombreDe(entrada)}: ${avisos.join(' · ')}` : null });
                this.cargar();
                if (this.props.onCambio) this.props.onCambio();
            })
            .catch((error) => this.setState({ aviso: error.message || 'No se pudo marcar el ingreso' }))
            .then(() => {
                if (this._desmontado) return;
                const trabajando = { ...this.state.trabajando };
                delete trabajando[id];
                this.setState({ trabajando });
            });
    }

    fila(entrada, primero) {
        const estado = entrada.status;
        const tipo = entrada.ticketType ? entrada.ticketType.name : '';
        const trabajando = this.state.trabajando[entrada.id];
        const borde = primero ? {} : { borderTop: `1px solid ${COLOR.bordeSuave}` };

        let accion = null;
        if (estado === 'valid') {
            accion = this.state.puedeHoy ? (
                <button
                    type="button"
                    onClick={trabajando ? undefined : () => this.marcarIngreso(entrada)}
                    style={{
                        fontSize: 12, fontWeight: 600, borderRadius: 6, padding: '6px 14px', cursor: 'pointer',
                        border: 'none', background: COLOR.accion, color: '#ffffff', flexShrink: 0,
                    }}
                >
                    {trabajando ? '…' : 'Ingresó'}
                </button>
            ) : null;
        } else if (estado === 'unpaid' || estado === 'pending') {
            accion = (
                <Link to={`/eventAdmissions?id=${this.props.evento.eventId}`} style={{ fontSize: 12, fontWeight: 600, flexShrink: 0 }}>
                    Cobrar →
                </Link>
            );
        } else if (estado === 'redeemed') {
            accion = <span style={{ fontSize: 12, color: COLOR.ok, fontWeight: 600, flexShrink: 0 }}>Adentro</span>;
        }

        const detalle = [
            tipo,
            entrada.cedula ? `CI ${entrada.cedula}` : null,
            estado === 'unpaid' ? 'sin cobrar' : null,
            estado === 'pending' ? 'pago por confirmar' : null,
        ].filter(Boolean).join(' · ');

        return (
            <div key={entrada.id} style={{ display: 'flex', alignItems: 'center', padding: '8px 16px', ...borde }}>
                <div style={{ flexGrow: 1, minWidth: 0 }}>
                    <div style={{ fontSize: 13, fontWeight: 600, color: COLOR.texto }}>{nombreDe(entrada)}</div>
                    {detalle ? (
                        <div style={{ fontSize: 11, marginTop: 1, color: estado === 'unpaid' || estado === 'pending' ? COLOR.aviso : COLOR.apagado }}>
                            {detalle}
                        </div>
                    ) : null}
                </div>
                {accion}
            </div>
        );
    }

    render() {
        const { evento } = this.props;
        const { entradas, busqueda, verAdentro } = this.state;
        const porcentaje = evento.esperados > 0 ? Math.round((evento.ingresaron / evento.esperados) * 100) : 0;

        // Las canceladas y las que esperan reembolso no son de nadie en la puerta.
        const vivas = (entradas || []).filter((e) => !['cancelled', 'refund_pending', 'refunded'].includes(e.status));
        const q = normalizar(busqueda);
        const coincide = (e) => !q || [nombreDe(e), e.cedula, e.holder_email, e.account && e.account.email]
            .some((campo) => normalizar(campo).includes(q));

        const porEntrar = vivas.filter((e) => e.status !== 'redeemed').filter(coincide);
        const adentro = vivas.filter((e) => e.status === 'redeemed').filter(coincide);
        // Primero los que pueden entrar ya; los que deben plata, después.
        porEntrar.sort((a, b) => (a.status === 'valid' ? 0 : 1) - (b.status === 'valid' ? 0 : 1));
        const visibles = porEntrar.slice(0, FILAS_A_LA_VISTA);

        return (
            <div className="card card-small mb-4" style={{ borderLeft: `4px solid ${COLOR.accion}` }}>
                <div style={{ padding: '14px 16px', display: 'flex', alignItems: 'center', gap: 16, flexWrap: 'wrap', borderBottom: `1px solid ${COLOR.borde}` }}>
                    <i className="material-icons" style={{ fontSize: 26, color: COLOR.accion }}>confirmation_number</i>
                    <div style={{ flexShrink: 0 }}>
                        <div style={{ fontSize: 15, fontWeight: 700, color: COLOR.texto }}>{evento.titulo}</div>
                        <div style={{ fontSize: 12, color: COLOR.apagado, marginTop: 2 }}>
                            Hoy {evento.hora} · {evento.ingresaron} de {evento.esperados} ingresaron
                            {evento.sinCobrar > 0 ? <span style={{ color: COLOR.aviso }}> · {evento.sinCobrar} sin cobrar</span> : null}
                        </div>
                    </div>
                    <div style={{ flexGrow: 1, minWidth: 140, height: 8, background: '#eef1f5', borderRadius: 4, overflow: 'hidden' }}>
                        <div style={{ width: `${porcentaje}%`, height: '100%', background: COLOR.ok }} />
                    </div>
                    {/* Lleva a Anotados con la venta presencial ya abierta. La pantalla es la que
                        sabe si el evento todavía se vende: si no, muestra el motivo. */}
                    <Link to={conVueltaAlHome(`/eventAdmissions?id=${evento.eventId}&vender=1`)} className="btn btn-sm btn-outline-primary" style={{ flexShrink: 0 }}>
                        Vender en la puerta
                    </Link>
                    <Link to={`/eventAdmissions?id=${evento.eventId}`} style={{ fontSize: 12, flexShrink: 0 }}>
                        Ver anotados completo
                    </Link>
                </div>

                <div style={{ padding: '10px 16px', borderBottom: `1px solid ${COLOR.bordeSuave}` }}>
                    <label htmlFor={`buscar-${evento.eventId}`} style={{ position: 'absolute', width: 1, height: 1, overflow: 'hidden', clip: 'rect(0 0 0 0)' }}>
                        Buscar asistente
                    </label>
                    <input
                        id={`buscar-${evento.eventId}`}
                        type="text"
                        className="form-control"
                        placeholder="Buscar por nombre, cédula o mail"
                        value={busqueda}
                        onChange={(e) => this.setState({ busqueda: e.target.value })}
                    />
                </div>

                {!this.state.puedeHoy && this.state.motivo ? (
                    <div style={{ padding: '10px 16px', fontSize: 12, color: COLOR.aviso }}>{this.state.motivo}</div>
                ) : null}
                {this.state.aviso ? (
                    <div style={{ padding: '10px 16px', fontSize: 12, color: COLOR.texto, background: '#fff8e6' }}>{this.state.aviso}</div>
                ) : null}
                {this.state.error ? (
                    <div style={{ padding: '10px 16px', fontSize: 12, color: COLOR.alerta }}>{this.state.error}</div>
                ) : null}

                {entradas === null && !this.state.error ? (
                    <div style={{ padding: '14px 16px', fontSize: 13, color: COLOR.apagado }}>…</div>
                ) : null}

                {entradas !== null && porEntrar.length === 0 ? (
                    <div style={{ padding: '14px 16px', fontSize: 13, color: COLOR.apagado }}>
                        {q ? 'Nadie por entrar con esa búsqueda.' : 'Ya entraron todos los anotados.'}
                    </div>
                ) : null}

                {visibles.map((e, i) => this.fila(e, i === 0))}

                {porEntrar.length > visibles.length ? (
                    <div style={{ padding: '6px 16px 8px 16px', fontSize: 12, color: COLOR.apagado }}>
                        + {porEntrar.length - visibles.length} más — buscá por nombre
                    </div>
                ) : null}

                {adentro.length > 0 ? (
                    <div style={{ borderTop: `1px solid ${COLOR.borde}` }}>
                        <button
                            type="button"
                            onClick={() => this.setState({ verAdentro: !verAdentro })}
                            style={{ background: 'none', border: 'none', padding: '9px 16px', fontSize: 12, color: COLOR.ok, fontWeight: 600, cursor: 'pointer' }}
                        >
                            {verAdentro ? '▾' : '▸'} {adentro.length} ya {adentro.length === 1 ? 'entró' : 'entraron'}
                        </button>
                        {verAdentro ? adentro.map((e, i) => this.fila(e, i === 0)) : null}
                    </div>
                ) : null}
            </div>
        );
    }
}

// Una banda por evento de hoy. Sin eventos (o si el bloque falló) no se dibuja nada: el home
// sin evento es el de siempre.
export default function BandasEventos({ eventos, onCambio }) {
    if (!eventos || eventos.length === 0) {
        return null;
    }
    return (
        <React.Fragment>
            {eventos.map((evento) => (
                <BandaEvento key={evento.eventId} evento={evento} onCambio={onCambio} />
            ))}
        </React.Fragment>
    );
}
